import React from "react";
import {
  applyMiddleware, combineReducers, compose, createStore,
} from "redux";
import { Provider } from "react-redux";
import thunkMiddleware from "redux-thunk";
import { fetch as router } from "helpers/router";
import PropTypes from "prop-types";
import retrieveUTM from "utils/UTM";
import request from "utils/request";
import { captcha } from "utils/requestHeaders";
import { submitFailedUserExists } from "./form/actions";
import Form from "./form/Form";
import Tips from "./tips/Tips";
import formReducer from "./form/reducer";
import tipsReducer from "./tips/reducer";

const initialState = {
  form: {
    startACampaign: {
      category: {},
      country: {},
    },
  },
};

const reducers = combineReducers({
  tips: tipsReducer,
  form: formReducer,
});

// create store, using the reducer provided by 'redux-form'
const store = createStore(
  reducers,
  initialState,
  compose(
    applyMiddleware(thunkMiddleware),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f,
  ),
);

const StartACampaignWidget = () => {
  const handleSubmit = (data, dispatch) => {
    const formData = {
      ...data,
      ...retrieveUTM(),
    };

    // set mixpanel id
    formData.anonymousId = (global.mixpanel && global.mixpanel.get_distinct_id)
      ? global.mixpanel.get_distinct_id()
      : null;

    // Get + set analytics parameters.
    // GTM should automatically set the cookie value when there's a new URL
    // parameter, but do a check of URL parameter in event of no cookies being set
    formData.uri = window.location.pathname;

    const req = request(router("api.v2.onboarding.store"), "POST", captcha("token", "v3"), formData);

    return fetch(req)
      .then((response) => {
        // conflict - user already exists
        if (response.status === 409) {
          response.json().then((json) => {
            dispatch(submitFailedUserExists(json.data.email));
          });
        }

        if (response.status === 200) {
          response.json().then((json) => {
            if (json.url) {
              window.location.href = json.url;
            }
          });
        }
      });
  };

  return (
    <Provider store={store}>
      <div>
        <div className="start-a-campaign-widget">
          <section className="start-a-campaign">
            <Form onSubmit={handleSubmit} />
          </section>
        </div>

        <div className="tips-widget">
          <Tips />
        </div>
      </div>
    </Provider>
  );
};

StartACampaignWidget.prototype = {
  captchaToken: PropTypes.string,
};

export default StartACampaignWidget;
